"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTitleBlock = parseTitleBlock;
exports.extractTitleBlock = extractTitleBlock;
const Util_1 = require("../../Util");
function parseTitleBlock(model, n) {
    const blockInfo = extractTitleBlock(n);
    if (blockInfo.title) {
        model.metadata.title = blockInfo.title;
    }
    if (blockInfo.date) {
        model.metadata.date = blockInfo.date;
    }
    if (blockInfo.revision) {
        model.metadata.revision = blockInfo.revision;
    }
    if (blockInfo.company) {
        model.metadata.company = blockInfo.company;
    }
    for (let i = 0; i < blockInfo.comments.length; ++i) {
        model.metadata[`comment ${i + 1}`] = blockInfo.comments[i];
    }
}
function extractTitleBlock(n) {
    const blockInfo = {
        comments: [],
    };
    for (const node of n.nodes) {
        switch (node.name) {
            case 'title':
                blockInfo.title = (0, Util_1.removeQuotes)(node.values[0]);
                break;
            case 'date':
                blockInfo.date = (0, Util_1.removeQuotes)(node.values[0]);
                break;
            case 'rev':
                blockInfo.revision = (0, Util_1.removeQuotes)(node.values[0]);
                break;
            case 'company':
                blockInfo.company = (0, Util_1.removeQuotes)(node.values[0]);
                break;
            case 'comment':
                blockInfo.comments.push((0, Util_1.removeQuotes)(node.values[1]));
                break;
        }
    }
    return blockInfo;
}
//# sourceMappingURL=v6ParseTitleBlock.js.map